import { useInventoryItemContext } from "./context";
import { Text } from '@constructor/components';
import { FC } from "react";

const InventoryItemCount: FC = (props) => {

    const item = useInventoryItemContext();
    if(!item) {
        return null;
    }

    const replaces = {
        item_count: item.count
    };

    return (
        <Text text={item.count} {...props} replaces={replaces} />
    )
}

export default InventoryItemCount;